export const SAVE_SETTINGS_MODE = {
  DEFAULT: 'default',
  NEW_PUBLISH: 'new_publish',
}

export const EDITOR_MAIN_SETTINGS = {
  RENDER: 'render',
  BEHAVIOUR: 'behaviour',
  VIEW: 'view',
} as const

export const EDITOR_MAIN_SETTINGS_MENU = [
  {
    name: 'EDITOR_MAIN_SETTINGS_MENU_ITEM_VIEW_SETTINGS',
    key: EDITOR_MAIN_SETTINGS.VIEW,
    visible: [], // for profiles, [] - empty array for all profiles
  },
  {
    name: 'EDITOR_MAIN_SETTINGS_MENU_ITEM_BEHAVIOUR_SETTINGS',
    key: EDITOR_MAIN_SETTINGS.BEHAVIOUR,
    visible: [], // for profiles, [] - empty array for all profiles
  },
  {
    name: 'EDITOR_MAIN_SETTINGS_MENU_ITEM_RENDER_SETTINGS',
    key: EDITOR_MAIN_SETTINGS.RENDER,
    visible: [], // for profiles, [] - empty array for all profiles
  },
]
